/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  home: () => import("@/views/home/index.vue"),
  post_form_photo_add: () => import("@/views/post/form/photo/add/index.vue"),
  post_form_photo_edit: () => import("@/views/post/form/photo/edit/[id].vue"),
  post: () => import("@/views/post/index.vue"),
  post_photo: () => import("@/views/post/photo/index.vue"),
  resources: () => import("@/views/resources/index.vue"),
  system_config_category_add: () => import("@/views/system/config/category/add/index.vue"),
  system_config_category_edit: () => import("@/views/system/config/category/edit/[id].vue"),
  system_config_category: () => import("@/views/system/config/category/index.vue"),
  system_config_item_add: () => import("@/views/system/config/item/add/index.vue"),
  system_config_item_edit: () => import("@/views/system/config/item/edit/[id].vue"),
  system_config_list: () => import("@/views/system/config/list/index.vue"),
  system_db: () => import("@/views/system/db/index.vue"),
};
